import Vue, { PluginObject } from 'vue'
import axios from 'axios'

import store from '@/store'
import router from '@/router'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  cfg => {
    if (store.getters.estAuthentifie) {
      let h = 'Bearer ' + store.getters.accessToken
      // console.log('axios: ajout header authorization ' + h)
      cfg.headers.Authorization = h
    } else {
      delete cfg.headers.Authorization
    }

    return cfg
  },
  err => {
    // Do something with request error
    return Promise.reject(err)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  res => {
    // Do something with response data
    return res
  },
  err => {
    console.log('Axios Interceptor err: ' + err)
    if (err.response !== undefined) {
      if (err.response.status === 401) {
        console.log('HTTP 401 recu, redirection vers /tokenexpire')
        store.dispatch('tokenExpire')
      }
    }

    return Promise.reject(err)
  }
)

const Plugin: PluginObject<any> = {
  install: Vue => {
    Vue.$axios = _axios
  }
}
Plugin.install = Vue => {
  Vue.$axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
